import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getData } from '../Services/api';



const CouponDetails = () => {
  const { code } = useParams();
  const [values, setValues] = useState({
    code: "",
    discountType: "percentage",
    discountValue: "",
    minOrderValue: "",
    maxDiscount: "",
    expiryDate: "",
    usageLimit: "",
  })
  const fetchCoupons = async () => {
    try {
      const res = await getData(`/coupons/${code}`);
      if (res.status) {
        setValues(res.data || {})
      }
    } catch (error) {
      console.log("error fetch coupon", error)
    }
  }

  useEffect(() => {
    fetchCoupons();
  }, [code]);



  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/coupons/coupon-list">Coupon</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Coupon Details
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0"> Coupon Details</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5> Coupon Details</h5>
                </div>
                <div className="card-body">
                  <form >
                    <div className="row">

                      <div className="col-md-6">
                        <label>Coupon Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="code"
                          value={values.code}
                          disabled
                          placeholder="SAVE20"
                        />
                      </div>

                      <div className="col-md-6">
                        <label>Discount Type</label>
                        <select
                          className="form-control"
                          name="discountType"
                          value={values.discountType}
                          disabled
                        >
                          <option value="percentage">Percentage</option>
                          <option value="flat">Flat</option>
                        </select>
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Discount Value</label>
                        <input
                          type="number"
                          className="form-control"
                          name="discountValue"
                          value={values.discountValue}
                          disabled
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Minimum Order Value</label>
                        <input
                          type="number"
                          className="form-control"
                          name="minOrderValue"
                          value={values.minOrderValue}
                          disabled
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Max Discount</label>
                        <input
                          type="number"
                          className="form-control"
                          name="maxDiscount"
                          value={values.maxDiscount}
                          disabled
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Expiry Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="expiryDate"
                          value={values.expiryDate?.split('T')[0]}
                          disabled
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Usage Limit</label>
                        <input
                          type="number"
                          className="form-control"
                          name="usageLimit"
                          value={values.usageLimit}
                          disabled
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CouponDetails